import React from 'react';
import { Modal } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import styles from './WelcomeModal.module.scss';

/**
 * 👋 WelcomeModal - Modal de boas-vindas para novos usuários
 * 
 * Features:
 * - Explicação resumida das funcionalidades
 * - Passos iniciais para começar
 * - Link para tela de Welcome completa
 */

const WelcomeModal = ({ show, onHide }) => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    onHide();
    navigate('/welcome');
  };

  const steps = [
    {
      icon: 'mdi:account-supervisor',
      title: 'Cadastre um Responsável',
      description: 'Antes de cadastrar um produto, você precisa criar um responsável pela conta. Esse responsável passará por um processo de aprovação de dados.',
      color: '#6366F1'
    },
    {
      icon: 'mdi:store',
      title: 'Afilie-se a Produtos',
      description: 'Para se afiliar a um produto, basta ir na Loja e solicitar afiliação. Após aprovação, você poderá promover e vender.',
      color: '#8B5CF6'
    },
    {
      icon: 'mdi:bank',
      title: 'Cadastre sua Conta Bancária',
      description: 'Para receber suas vendas e pagamentos de comissões, você precisa cadastrar uma conta bancária vinculada ao responsável.',
      color: '#EC4899'
    },
    {
      icon: 'mdi:cash-multiple',
      title: 'Realize Saques',
      description: 'Com saldo disponível, você pode solicitar saques. Valor mínimo de R$ 100,00 e disponível 1x por dia.',
      color: '#10B981'
    }
  ];

  return (
    <Modal 
      show={show} 
      onHide={onHide}
      centered
      backdrop="static"
      backdropClassName="modal-backdrop-lightbox"
      className={styles.welcomeModal}
      size="lg"
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          <Icon icon="mdi:party-popper" className={styles.titleIcon} />
          Bem-vindo à Pagmus!
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles.modalBody}>
        {/* Mensagem de boas-vindas */}
        <div className={styles.welcomeMessage}>
          <p className={styles.welcomeText}>
            Estamos felizes em ter você conosco! Aqui está um guia rápido para você começar:
          </p>
        </div>

        {/* Passos */}
        <div className={styles.stepsSection}>
          {steps.map((step, index) => (
            <div key={index} className={styles.stepCard}>
              <div className={styles.stepHeader}>
                <div 
                  className={styles.stepIcon}
                  style={{ backgroundColor: `${step.color}15`, color: step.color }}
                >
                  <Icon icon={step.icon} />
                </div>
                <div className={styles.stepNumber}>{index + 1}</div>
              </div>
              <div className={styles.stepContent}>
                <span 
                  className={styles.stepTitle}
                  style={{ 
                    fontSize: '13px', 
                    display: 'block',
                    fontWeight: '600'
                  }}
                >
                  {step.title}
                </span>
                <p className={styles.stepDescription}>
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Dicas Importantes */}
        <div className={styles.tipsSection}>
          <div className={styles.tipBox}>
            <Icon icon="mdi:information-outline" className={styles.tipIcon} />
            <div className={styles.tipContent}>
              <strong>Dica Importante:</strong> Todas as informações cadastradas passam por um processo de aprovação para garantir a segurança da plataforma.
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className={styles.modalFooter}>
        <button 
          type="button" 
          className={styles.secondaryButton} 
          onClick={onHide}
        >
          Fechar
        </button>
        <button 
          type="button" 
          className={styles.primaryButton}
          onClick={handleLearnMore}
        >
          <Icon icon="mdi:book-open-variant" className="me-2" />
          Quero Saber Mais
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default WelcomeModal;

